import * as React from 'react';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { ProductDetailTitle } from './ProductDetailTitle.js';
import { isContactLensVariant } from '../../../types/typeguards.js';
import { getBrandLink } from '../utils/get-brand-link.js';
import { useProductData } from '../../../context/product-context-hooks.js';

const ProductDetailTitleContainer = ()=>{
    const isClient = useIsClient();
    const { activeVariant , product: { brandName  } ,  } = useProductData();
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const isContactLens = isContactLensVariant(activeVariant);
    const brandUrl = React.useMemo(()=>{
        if (!isClient || isContactLens) return undefined;
        if (isSubcategoryPlpLinkingDisabled) return undefined;
        return getBrandLink(brandName, window.location.pathname);
    }, [
        brandName,
        isClient,
        isSubcategoryPlpLinkingDisabled
    ]);
    const title = activeVariant.displayName;
    let subtitle = brandName;
    if (isContactLens && activeVariant.replacementFrequency) {
        subtitle = activeVariant.replacementFrequency;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: title,
        subtitle: subtitle,
        href: brandUrl,
        sku: activeVariant.sku
    });
};

export { ProductDetailTitleContainer };
//# sourceMappingURL=ProductDetailTitleContainer.js.map
